import { render, staticRenderFns } from "./ProductsFromOffer.vue?vue&type=template&id=1b548085&"
import script from "./ProductsFromOffer.vue?vue&type=script&lang=js&"
export * from "./ProductsFromOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports